"use strict";
import useENSAddress from "hooks/useENSAddress";
import useENSName from "hooks/useENSName";
import { useMemo } from "react";
import { isAddress } from "utilities/src/addresses";
export default function useENS(nameOrAddress) {
  const validated = isAddress(nameOrAddress);
  const reverseLookup = useENSName(validated ? validated : void 0);
  const lookup = useENSAddress(nameOrAddress);
  return useMemo(
    () => ({
      loading: reverseLookup.loading || lookup.loading,
      address: validated ? validated : lookup.address,
      name: reverseLookup.ENSName ? reverseLookup.ENSName : !validated && lookup.address ? nameOrAddress || null : null
    }),
    [lookup.address, lookup.loading, nameOrAddress, reverseLookup.ENSName, reverseLookup.loading, validated]
  );
}
